// Fetch availability
export const NUMEROLOGY_AVAILABILITY_REQUEST = 'NUMEROLOGY_AVAILABILITY_REQUEST';
export const numerologyAvailabilityRequest = () =>
  ({ type: NUMEROLOGY_AVAILABILITY_REQUEST });

export const NUMEROLOGY_AVAILABILITY_SUCCESS = 'NUMEROLOGY_AVAILABILITY_SUCCESS';
export const numerologyAvailabilitySuccess = (available) =>
  ({ type: NUMEROLOGY_AVAILABILITY_SUCCESS, payload: { available } });

export const NUMEROLOGY_AVAILABILITY_ERROR = 'NUMEROLOGY_AVAILABILITY_ERROR';
export const numerologyAvailabilityError = (error) =>
  ({ type: NUMEROLOGY_AVAILABILITY_ERROR, payload: error });

// Calculate (free tier)
export const NUMEROLOGY_CALCULATE_REQUEST = 'NUMEROLOGY_CALCULATE_REQUEST';
export const numerologyCalculateRequest = (fullName, birthDate, pronouns) =>
  ({
    type: NUMEROLOGY_CALCULATE_REQUEST,
    payload: {
      full_name: fullName,
      birth_date: birthDate,
      pronouns: pronouns || 'ella',
    },
  });

export const NUMEROLOGY_CALCULATE_SUCCESS = 'NUMEROLOGY_CALCULATE_SUCCESS';
export const numerologyCalculateSuccess = (reading) =>
  ({ type: NUMEROLOGY_CALCULATE_SUCCESS, payload: { reading } });

export const NUMEROLOGY_CALCULATE_ERROR = 'NUMEROLOGY_CALCULATE_ERROR';
export const numerologyCalculateError = (error) =>
  ({ type: NUMEROLOGY_CALCULATE_ERROR, payload: error });

// Premium reading
export const NUMEROLOGY_PREMIUM_REQUEST = 'NUMEROLOGY_PREMIUM_REQUEST';
export const numerologyPremiumRequest = (readingId, email) =>
  ({ type: NUMEROLOGY_PREMIUM_REQUEST, payload: { reading_id: readingId, email } });

export const NUMEROLOGY_PREMIUM_SUCCESS = 'NUMEROLOGY_PREMIUM_SUCCESS';
export const numerologyPremiumSuccess = (data) =>
  ({ type: NUMEROLOGY_PREMIUM_SUCCESS, payload: { data } });

export const NUMEROLOGY_PREMIUM_ERROR = 'NUMEROLOGY_PREMIUM_ERROR';
export const numerologyPremiumError = (error) =>
  ({ type: NUMEROLOGY_PREMIUM_ERROR, payload: error });

export const NUMEROLOGY_PREMIUM_PENDING = 'NUMEROLOGY_PREMIUM_PENDING';
export const numerologyPremiumPending = (etaAt) =>
  ({ type: NUMEROLOGY_PREMIUM_PENDING, payload: { etaAt } });

// Compatibility
export const NUMEROLOGY_COMPATIBILITY_REQUEST = 'NUMEROLOGY_COMPATIBILITY_REQUEST';
export const numerologyCompatibilityRequest = (readingId, partnerName) =>
  ({ type: NUMEROLOGY_COMPATIBILITY_REQUEST, payload: { reading_id: readingId, partner_name: partnerName } });

export const NUMEROLOGY_COMPATIBILITY_SUCCESS = 'NUMEROLOGY_COMPATIBILITY_SUCCESS';
export const numerologyCompatibilitySuccess = (data) =>
  ({ type: NUMEROLOGY_COMPATIBILITY_SUCCESS, payload: { data } });

export const NUMEROLOGY_COMPATIBILITY_ERROR = 'NUMEROLOGY_COMPATIBILITY_ERROR';
export const numerologyCompatibilityError = (error) =>
  ({ type: NUMEROLOGY_COMPATIBILITY_ERROR, payload: error });

// Like
export const NUMEROLOGY_LIKE_REQUEST = 'NUMEROLOGY_LIKE_REQUEST';
export const numerologyLikeRequest = (readingId, like) =>
  ({ type: NUMEROLOGY_LIKE_REQUEST, payload: { reading_id: readingId, like } });

export const NUMEROLOGY_LIKE_SUCCESS = 'NUMEROLOGY_LIKE_SUCCESS';
export const numerologyLikeSuccess = () =>
  ({ type: NUMEROLOGY_LIKE_SUCCESS });

// Numbers catalog
export const NUMEROLOGY_NUMBERS_REQUEST = 'NUMEROLOGY_NUMBERS_REQUEST';
export const numerologyNumbersRequest = () =>
  ({ type: NUMEROLOGY_NUMBERS_REQUEST });

export const NUMEROLOGY_NUMBERS_SUCCESS = 'NUMEROLOGY_NUMBERS_SUCCESS';
export const numerologyNumbersSuccess = (numbers) =>
  ({ type: NUMEROLOGY_NUMBERS_SUCCESS, payload: { numbers } });

export const NUMEROLOGY_NUMBERS_ERROR = 'NUMEROLOGY_NUMBERS_ERROR';
export const numerologyNumbersError = (error) =>
  ({ type: NUMEROLOGY_NUMBERS_ERROR, payload: error });

// Reset
export const NUMEROLOGY_RESET = 'NUMEROLOGY_RESET';
export const numerologyReset = () =>
  ({ type: NUMEROLOGY_RESET });

// Anonymous per-reading pending creation (pay-to-generate landing)
export const CREATE_PENDING_NUMEROLOGY_REQUEST = 'NUMEROLOGY/CREATE_PENDING_REQUEST';
export const createPendingNumerologyRequest = (payload) =>
  ({ type: CREATE_PENDING_NUMEROLOGY_REQUEST, payload });

export const CREATE_PENDING_NUMEROLOGY_SUCCESS = 'NUMEROLOGY/CREATE_PENDING_SUCCESS';
export const createPendingNumerologySuccess = (readingId, fullName) =>
  ({ type: CREATE_PENDING_NUMEROLOGY_SUCCESS, payload: { readingId, fullName } });

export const CREATE_PENDING_NUMEROLOGY_FAILURE = 'NUMEROLOGY/CREATE_PENDING_FAILURE';
export const createPendingNumerologyFailure = (error) =>
  ({ type: CREATE_PENDING_NUMEROLOGY_FAILURE, payload: error });

// Consulta a la medida — crea la lectura kind=consulta antes del checkout.
// Reusa los mismos *_SUCCESS/FAILURE que el pending normal para que
// PayToGenerateFlow (pendingReadingId) funcione sin cambios.
export const CREATE_CONSULTA_NUMEROLOGY_REQUEST = 'NUMEROLOGY/CREATE_CONSULTA_REQUEST';
export const createConsultaNumerologyRequest = (payload) =>
  ({ type: CREATE_CONSULTA_NUMEROLOGY_REQUEST, payload });

// El día de tu boda — crea la lectura kind=boda (2 novios + fecha + lugar)
// antes del checkout. Reusa calculate_boda en el saga y los mismos
// *_SUCCESS/FAILURE para que PayToGenerateFlow funcione sin cambios.
export const CREATE_BODA_NUMEROLOGY_REQUEST = 'NUMEROLOGY/CREATE_BODA_REQUEST';
export const createBodaNumerologyRequest = (payload) =>
  ({ type: CREATE_BODA_NUMEROLOGY_REQUEST, payload });

// Anonymous per-reading checkout (Stripe)
export const NUMEROLOGY_CHECKOUT_REQUEST = 'NUMEROLOGY_CHECKOUT_REQUEST';
export const numerologyCheckoutRequest = (email, readingId) =>
  ({ type: NUMEROLOGY_CHECKOUT_REQUEST, payload: { email, reading_id: readingId } });

export const NUMEROLOGY_CHECKOUT_SUCCESS = 'NUMEROLOGY_CHECKOUT_SUCCESS';
export const numerologyCheckoutSuccess = (checkoutUrl) =>
  ({ type: NUMEROLOGY_CHECKOUT_SUCCESS, payload: { checkoutUrl } });

export const NUMEROLOGY_CHECKOUT_FAILURE = 'NUMEROLOGY_CHECKOUT_FAILURE';
export const numerologyCheckoutFailure = (error) =>
  ({ type: NUMEROLOGY_CHECKOUT_FAILURE, payload: error });

// Anonymous per-reading PayPal order
export const NUMEROLOGY_PAYPAL_ORDER_REQUEST = 'NUMEROLOGY_PAYPAL_ORDER_REQUEST';
export const numerologyPaypalOrderRequest = (email, readingId) =>
  ({ type: NUMEROLOGY_PAYPAL_ORDER_REQUEST, payload: { email, reading_id: readingId } });

export const NUMEROLOGY_PAYPAL_ORDER_SUCCESS = 'NUMEROLOGY_PAYPAL_ORDER_SUCCESS';
export const numerologyPaypalOrderSuccess = (approveUrl) =>
  ({ type: NUMEROLOGY_PAYPAL_ORDER_SUCCESS, payload: { approveUrl } });

export const NUMEROLOGY_PAYPAL_ORDER_FAILURE = 'NUMEROLOGY_PAYPAL_ORDER_FAILURE';
export const numerologyPaypalOrderFailure = (error) =>
  ({ type: NUMEROLOGY_PAYPAL_ORDER_FAILURE, payload: error });

// Verify Stripe purchase on return
export const NUMEROLOGY_VERIFY_PURCHASE_REQUEST = 'NUMEROLOGY_VERIFY_PURCHASE_REQUEST';
export const numerologyVerifyPurchaseRequest = (sessionId) =>
  ({ type: NUMEROLOGY_VERIFY_PURCHASE_REQUEST, payload: { session_id: sessionId } });

export const NUMEROLOGY_VERIFY_PURCHASE_SUCCESS = 'NUMEROLOGY_VERIFY_PURCHASE_SUCCESS';
export const numerologyVerifyPurchaseSuccess = (data) =>
  ({ type: NUMEROLOGY_VERIFY_PURCHASE_SUCCESS, payload: data });

export const NUMEROLOGY_VERIFY_PURCHASE_FAILURE = 'NUMEROLOGY_VERIFY_PURCHASE_FAILURE';
export const numerologyVerifyPurchaseFailure = (error) =>
  ({ type: NUMEROLOGY_VERIFY_PURCHASE_FAILURE, payload: error });

// Verify PayPal purchase on return
export const NUMEROLOGY_VERIFY_PAYPAL_REQUEST = 'NUMEROLOGY_VERIFY_PAYPAL_REQUEST';
export const numerologyVerifyPaypalRequest = (paypalOrderId) =>
  ({ type: NUMEROLOGY_VERIFY_PAYPAL_REQUEST, payload: { paypal_order_id: paypalOrderId } });

export const NUMEROLOGY_VERIFY_PAYPAL_SUCCESS = 'NUMEROLOGY_VERIFY_PAYPAL_SUCCESS';
export const numerologyVerifyPaypalSuccess = (data) =>
  ({ type: NUMEROLOGY_VERIFY_PAYPAL_SUCCESS, payload: data });

export const NUMEROLOGY_VERIFY_PAYPAL_FAILURE = 'NUMEROLOGY_VERIFY_PAYPAL_FAILURE';
export const numerologyVerifyPaypalFailure = (error) =>
  ({ type: NUMEROLOGY_VERIFY_PAYPAL_FAILURE, payload: error });
